import type { GameEngine } from '@shared/gameContracts';
import { nassauEngine } from './nassau';
import { skinsEngine } from './skins';

const engineRegistry = new Map<string, GameEngine>();

engineRegistry.set('nassau', nassauEngine);
engineRegistry.set('skins', skinsEngine);

export function getGameEngine(gameId?: string): GameEngine {
  if (!gameId) return nassauEngine;

  const engine = engineRegistry.get(gameId);
  if (engine) return engine;

  console.warn(`[GameRegistry] Unknown game type "${gameId}", falling back to Nassau`);
  return nassauEngine;
}

export function registerGameEngine(gameId: string, engine: GameEngine): void {
  engineRegistry.set(gameId, engine);
}

export function getAvailableGameTypes(): string[] {
  return Array.from(engineRegistry.keys());
}

export { isPressCapable } from '@shared/gameContracts';
export type { GameEngine, PressCapableEngine } from '@shared/gameContracts';
